import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/AuthContext";
import { base44 } from "@/api/base44Client";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";
import FitnessGoals from "@/components/account/FitnessGoals";

const GOAL_LABELS = {
  weight: "Target Weight",
  body_fat: "Body Fat %",
  chest: "Chest",
  waist: "Waist",
  hips: "Hips",
  arms: "Arms",
  thighs: "Thighs",
};

export default function MyGoals() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { data: pastGoals = [] } = useQuery({
    queryKey: ["past_goals", user?.id],
    queryFn: () => base44.entities.FitnessGoal.filter({ is_active: false, created_by_id: user?.id }, "-updated_date", 50),
    enabled: !!user,
  });

  return (
    <div className="max-w-2xl mx-auto space-y-6 pt-2">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/")}
          className="hover:bg-secondary"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-2xl font-display font-bold">My Goals</h1>
      </div>

      <FitnessGoals />

      {/* Past Goals */}
      {pastGoals.length > 0 && (
        <div className="space-y-4">
          <h2 className="text-lg font-semibold">Past Goals</h2>
          <div className="space-y-3">
            {pastGoals.map((goal) => (
              <Card key={goal.id} className="p-4 border-0 shadow-sm opacity-75">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium">{GOAL_LABELS[goal.goal_type]}</p>
                    <p className="text-xs text-muted-foreground">
                      Target: {goal.target_value} {goal.unit}
                      {goal.current_value ? ` • Achieved: ${goal.current_value}` : ""}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-muted-foreground">Completed</p>
                    <p className="text-xs text-muted-foreground">{format(parseISO(goal.updated_date), "MMM d, yyyy")}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}